export {
  isClerkAPIResponseError,
  isEmailLinkError,
  isKnownError,
  isMetamaskError,
  EmailLinkErrorCode,
} from '@clerk/shared/error';
